import React from 'react'
import PropTypes from 'prop-types'
import NoResults from '../../pages/shared/NoResults'
import StatusDisplay from './StatusDisplay'
import dayjs from 'dayjs'
import { generatePath, Link } from 'react-router-dom'
import { ROUTES } from '../../routes'

export default function ClientImportsTable ({ clientImports }) {
  return (
    <div className='table-responsive'>
      <table className='table table-striped'>
        <thead>
          <tr>
            <th width='10%'>Status</th>
            <th width='20%'>Started At</th>
            <th width='20%'>Created By</th>
            <th width='10%'>Total Rows</th>
            <th width='10%'>Valid Rows</th>
            <th width='10%'>Invalid Rows</th>
            <th width='10%'>Action</th>
          </tr>
        </thead>
        <tbody>
          {clientImports.length === 0 && (
            <tr><td colSpan='7'><NoResults /></td></tr>
          )}
          {clientImports.map(clientImport => (
            <tr key={clientImport.id}>
              <td className='flex justify-center'>
                <StatusDisplay status={clientImport.status} />
              </td>
              <td>{dayjs(clientImport.createdAt).format('MMM D, YYYY h:mm a')}</td>
              <td>{`${clientImport.creatingUser.firstName} ${clientImport.creatingUser.lastName}`}</td>
              <td>{clientImport.validRowsCount + clientImport.invalidRowsCount}</td>
              <td>{clientImport.validRowsCount}</td>
              <td>{clientImport.invalidRowsCount}</td>
              <td>
                <Link to={generatePath(ROUTES.clientImport, { clientImportId: clientImport.id })} className='btn btn-sm btn-primary-dk'>
                  Details
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

ClientImportsTable.propTypes = {
  clientImports: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    status: PropTypes.oneOf(['COMPLETED', 'CREATING_RECORDS', 'NEW', 'PARSING', 'PARSING_FAILED', 'VALIDATED']),
    createdAt: PropTypes.string.isRequired,
    validRowsCount: PropTypes.number.isRequired,
    invalidRowsCount: PropTypes.number.isRequired,
    creatingUser: PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string
    }).isRequired
  })).isRequired
}
